// @flow

import React, { useState, useEffect } from "react";
import AsyncApi from "@asyncapi/react-component";

const AsyncApiDocs = () => {

	const [scheme, setScheme] = useState('');

	const urlParams = new URLSearchParams(window.location.search);
  	const environment = urlParams.get('env') || 'production';

	const asyncApiUrl = environment === 'production'
      ? 'https://integration.phxp.huddle.tech/api/v1/docs/asyncapi'
      : 'https://integration.s.huddle.tech/api/v1/docs/asyncapi';

	useEffect(() => {
		fetch(asyncApiUrl)
			.then(response => {
				return response.text();
			})
			.then(data => {
				setScheme(data);
			})
			.catch(err => {
				console.log('err', err);
			});
	}, []);

  return (
    <AsyncApi schema={scheme} config={ { show: { sidebar: true } } } />
  );
};

export default AsyncApiDocs;
